import BaseController from './BaseController'
import Scrollbar from 'smooth-scrollbar'


export default class InfosController extends BaseController {

  init() {
   
    this.initScrollbar()
    this.revealAnimate()
    this.listeners()
    this.openings()
    this.contact()

    this.$dones = []
  }

  openings() {
    const $days = document.querySelectorAll('.openings__week-day')
    const $dayTexts = document.querySelectorAll('.openings__day')
    const $times = document.querySelectorAll('.openings__time')

    let d = new Date()

    const currentDay = $times[d.getDay()-1]
    currentDay.classList.add('selected')
    currentDay.style.transform = 'translate(0)'
    

    for (let i = 0; i < $dayTexts.length; i++) {
      $dayTexts[i].addEventListener('click', () => {
        for (const $day of $days) {
          $day.classList.remove('selected')
          TweenMax.to($day.querySelector('.openings__time'), .5,
            { x: `-${window.innerWidth}px`, ease: Expo.easeOut }
          )
        }
        $days[i].classList.add('selected')
        TweenMax.fromTo($days[i].querySelector('.openings__time'), .5,
          { x: `${window.innerWidth}px`, ease: Expo.easeOut },
          { x: '0', ease: Power1.easeOut }
        )
      })
    }
  }

  listeners() {
    this.scrollbar.addListener(() => { this._handleReveals() })
  }

  contact() {
    const $emailInput = document.querySelector('.contact__email')
    const $submit = document.querySelector('.contact__input')

    const mailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    $emailInput.addEventListener('input', () => {
      if (
        $emailInput.value.match(mailRegex) &&
        $emailInput.value.length > 5
      ) {
        $submit.classList.remove('mainButton--inactive')
      }
      else {
        $submit.classList.add('mainButton--inactive')
      }
    })
  }

  revealAnimate() {
    const $background = document.querySelector('.subscriptions__background')
    const $thumbnails = document.querySelectorAll('.subscriptions__thumbnail-parent')
    const $block = document.querySelectorAll('.subscriptions__price')
    const $title = document.querySelector('.subscriptions__title')
    const $legal = document.querySelectorAll('.subscriptions__legal')
    const $age = document.querySelectorAll('.subscriptions__formula-title div')
    const $price = document.querySelectorAll('.subscriptions__price-value')
    const $length = document.querySelectorAll('.subscriptions__price-length')
    const $subtitle = document.querySelectorAll('.subscriptions__subtitle')

    const timeline = new TimelineMax()

    timeline
      .from($background, 1.5, {
        scaleY: 0,
        y: '50px',
        ease: CustomEase.create("custom", "M0,0 C0.305,0 -0.02,1.126 1,1.126")
      }, 'infosReveal')
      .staggerFrom($thumbnails, 1, {
        height: 0,
        ease: CustomEase.create("custom", "M0,0 C0.305,0 -0.02,1.126 1,1.126")
      }, 0, 'infosReveal')
      .staggerFrom($block, 1, {
        height: 0,
        y: '30px',
        ease: CustomEase.create("custom", "M0,0 C0.305,0 -0.02,1.126 1,1.126")
      }, 0, 'infosReveal')
      .from($title, 1, {
        y: '100%',
        x: '-10px',
        skewX: '-15deg',
        ease: Circ.easeOut
      }, 'infosReveal+=.5')
      .from($subtitle, 1, {
        y: '100%',
        x: '-10px',
        skewX: '-15deg',
        ease: Circ.easeOut
      }, 'infosReveal+=.6')
      .staggerFrom($price, 1, {
        y: '100%',
        x: '-10px',
        skewX: '-15deg',
        ease: Circ.easeOut
      }, 0, 'infosReveal+=.7')
      .staggerFrom($age, 1, {
        y: '100%',
        x: '-10px',
        skewX: '-15deg',
        ease: Circ.easeOut
      }, 0, 'infosReveal+=.8')
      .staggerFrom($legal, 1, {
        y: '100%',
        x: '-10px',
        skewX: '-15deg',
        ease: Circ.easeOut
      }, 0, 'infosReveal+=.9')
      .staggerFrom($length, 1, {
        y: '100%',
        x: '-10px',
        skewX: '-15deg',
        ease: Circ.easeOut
      }, 0, 'infosReveal+=1')
  }

  _isDone($current) {
    for (const $done of this.$dones) {
      if ($done == $current) return true
    }
    this.$dones.push($current)
    return false
  }

  _handleReveals() {
    const $openingsTitle = document.querySelector('.openings__title')
    const $openingsWeekDays = document.querySelectorAll('.openings__day')
    const $openingsRectangles = document.querySelectorAll('.openings__day rect')
    const $openingsHours = document.querySelectorAll('.openings__text')

    const $map = document.querySelector('.map')
    const $mapAsides = document.querySelectorAll('.map__aside div')
    const $mapImage = document.querySelector('.map__image')

    if (this.isOnWindow($openingsTitle).isOnWindow && !this._isDone($openingsTitle)) {
      const timeline = new TimelineMax()
      timeline
        .from($openingsTitle, 1, {
          y: '100%',
          x: '-10px',
          skewX: '-15deg',
          ease: Circ.easeOut
        }, 'opening')
        .staggerFrom($openingsWeekDays, .4, {
          y: '100%',
          ease: Circ.easeOut
        }, .1, 'opening+=.3')
        .staggerFrom($openingsHours, .4, {
          y: '100%',
          x: '-10px',
          skewX: '-15deg',
          ease: Circ.easeOut
        }, 0, 'opening+=.2')
        .to($openingsRectangles, 2, {
          strokeDashoffset: 0,
          ease: Circ.easeOut
        }, 'opening+=.5')
    }

    if (this.isOnWindow($map).isOnWindow && !this._isDone($map)) {
      const timeline = new TimelineMax()
      timeline
        .from($mapImage, .5, {
          width: 0,
          ease: Circ.easeOut
        }, .1, 'map')
        .staggerFrom($mapAsides, .5, {
          y: '50px',
          opacity: 0,
          ease: Circ.easeOut,
        }, .1, 'map+=.1')

      const $textarea = document.querySelector('.contact__textarea')
      const hello = $textarea.value
      $textarea.innerText = ''
      const letters = hello.split('')
      let i = 0
      const addLetter = () => {
        $textarea.innerText = $textarea.value + letters[i]
        i++
        if (i < letters.length) setTimeout(addLetter, 200)
      }
      setTimeout(addLetter, 1000)
    }
  }
}